import { format } from 'date-fns';
import { ProvisionedAuditLog } from '@beable/roster-backend-client-v1';

export function formatLogText(log: ProvisionedAuditLog) {
  const setAt = format(new Date(log.setAt), 'dd-MMM-yyyy');

  if (log.setBySource === 'System') {
    return `${log.event}ed by System on ${setAt}`;
  }
  if (log.setByUsername) {
    return `${log.event}ed by ${log.setByUsername} on ${setAt}`;
  }
  return `${log.event}ed on ${setAt}`;
}
